import { render, staticRenderFns } from "./ordinary.vue?vue&type=template&id=2e7899d7&scoped=true"
import script from "./ordinary.vue?vue&type=script&lang=js"
export * from "./ordinary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7899d7",
  null
  
)

export default component.exports